module.exports = __webpack_public_path__ + "img/shopOne.5a4ae308.png";